<template>
  <form @submit.prevent="submitForm()" @reset.prevent="resetForm()">
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-key" /></div>
        <input
          type="text"
          name="code"
          v-model="form.code"
          class="form-control"
          :class="{ 'form-control-sm': position == 'aside', 'is-invalid': errors.form.code.length }"
          :placeholder="`код из ${type == 'sms' ? 'смс' : 'письма'}`"
          :disabled="seconds == 0" />
        <div v-if="errors.form.code.length" class="invalid-feedback">{{ errors.form.code }}</div>
      </div>
    </div>

    <div v-if="seconds > -1" class="my-1">
      <small v-if="seconds == 0" class="text-muted">Код истёк, получите новый.</small>
      <small v-if="seconds > 0" class="text-muted">Действует ещё {{ secondsFormatted }}</small>
    </div>

    <div data-error class="alert alert-warning mb-1 mt-1 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button
        type="reset"
        class="btn btn-secondary-outline"
        :disabled="isLoading"
        :class="{ 'btn-sm': position == 'aside' }"
        title="Вернуться">
        <font-awesome-icon icon="fa-solid fa-arrow-left" /> Назад
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="form.code.length == 0 || isLoading"
        :class="{ 'btn-sm': position == 'aside' }"
        title="Войти на сайт">
        <font-awesome-icon icon="fa-solid fa-user" /> Войти
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

// import {plural} from '@/composable/functions';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faKey, faArrowLeft, faUser } from '@fortawesome/free-solid-svg-icons';
library.add(faKey, faArrowLeft, faUser);

export default {
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        uid: '',
        code: '',
      },
      errors: {
        form: {
          code: '',
          common: '',
        },
      },
      // таймер
      timer: null,
      seconds: -1,
    };
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    uid: {
      type: Number,
      default: 0,
    },
    until: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (['email', 'sms'].indexOf(this.type) === -1) {
        this.errors.form.common = 'Не указан тип формы.';
        return false;
      }

      if (this.form.code.length == 0) {
        if (this.type === 'sms') {
          this.errors.form.code = 'Нужно ввести код из смс.';
        }
        if (this.type === 'email') {
          this.errors.form.code = 'Нужно ввести код из письма.';
        }

        return false;
      }

      this.isLoading = true;

      axios
        .post(`/backend/login/response`, this.form)
        .then((res) => {
          // ??? надо?
          if (res.data.message !== '') {
            this.$bs5utils.Snack.show('info', res.data.message, this.$store.getters.delay.info);
          }

          if (res.data.status === 'ok') {
            this.errors.form.common = res.data.message;
            this.form.uid = 0;
            this.form.code = '';

            // similar behavior as an HTTP redirect
            // window.location.replace("http://stackoverflow.com");
            // similar behavior as clicking on a link
            // window.location.href = "http://stackoverflow.com";

            // if (res.data.redirect !== '') {
            // window.location.replace(res.data.redirect);
            // }

            window.location.reload();
          }

          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.$emit('go-step', { step: 0, uid: '', until: '' });
    },
    until_seconds() {
      if (this.until.length == 0) {
        return 0;
      }

      const now = new Date();
      const until = new Date(this.until);

      // если прошло, то вернуть 0
      return until < now ? 0 : Math.floor((until - now) / 1000);
    },
    until_timer() {
      clearInterval(this.timer);

      this.timer = setInterval(() => {
        this.seconds = this.until_seconds();

        if (this.seconds == 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  watch: {
    'form.code'(newVal, oldVal) {
      if (newVal.length != oldVal.length) {
        this.errors.form.code = '';
      }
    },
  },
  computed: {
    secondsFormatted() {
      const s = parseInt(this.seconds);
      if (s == -1) {
        return '';
      }

      const tm = Math.floor(s / 60) ? `${Math.floor(s / 60)} мин. ` : '';
      const ts = `${(s % 60).toString().padStart(2, '0')} сек.`;

      return `${tm}${ts}`;
      // return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;
    },
  },
  created() {
    this.form.uid = this.uid;
  },
  mounted() {
    if (this.until.length) {
      this.until_timer();
    }
  },
};
</script>
